import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class LoginPromptStore {
    password: string = "";
    errorVisible: boolean = false;
    errorMessage: string = "";

    rootStore: IRootStore;
    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    setPassword = (pwdInputVal: string) => {
        this.password = pwdInputVal;
    }
    get getPassword() {
        return this.password;
    }

    setError = (isErrorVisible: boolean, errorMessage: string) => {
        this.errorVisible = isErrorVisible;
        this.errorMessage = errorMessage;
    }

    get getIsErrorVisible() {
        return this.errorVisible;
    }
    get getErrorMsg() {
        return this.errorMessage;
    }
} 